import { createContext } from "react";

import { AssistantTone } from "#/types/assistant";

export interface AssistantUiMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
}

export interface AssistantChatContextType {
  messages: AssistantUiMessage[];
  isOpen: boolean;
  isMaximized: boolean;
  isSending: boolean;
  tone: AssistantTone;
  open: () => void;
  close: () => void;
  toggleMaximized: () => void;
  setTone: (tone: AssistantTone) => void;
  sendMessage: (text: string) => void;
  clear: () => void;
}

export const AssistantChatContext =
  createContext<AssistantChatContextType | null>(null);
